import app from 'flarum/forum/app';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
import DetailedDropdownItem from 'flarum/common/components/DetailedDropdownItem';
import SplitDropdown from 'flarum/common/components/SplitDropdown';
import Icon from 'flarum/common/components/Icon';
export default class SubscriptionMenu extends Dropdown {
  options = (() => [{
    subscription: null,
    icon: m(Icon, {
      name: "fa-regular fa-star",
      className: "Button-icon",
      noStyleOverride: true
    }),
    label: app.translator.trans('flarum-subscriptions.forum.sub_controls.not_following_button'),
    description: app.translator.trans('flarum-subscriptions.forum.sub_controls.not_following_text')
  }, {
    subscription: 'follow',
    icon: m(Icon, {
      name: "fa-solid fa-star",
      className: "Button-icon",
      noStyleOverride: true
    }),
    label: app.translator.trans('flarum-subscriptions.forum.sub_controls.following_button'),
    description: app.translator.trans('flarum-subscriptions.forum.sub_controls.following_text')
  }, {
    subscription: 'ignore',
    icon: 'far fa-eye-slash',
    label: app.translator.trans('flarum-subscriptions.forum.sub_controls.ignoring_button'),
    description: app.translator.trans('flarum-subscriptions.forum.sub_controls.ignoring_text')
  }])();
  possibleButtonAttrs = (() => ({
    null: {
      icon: m(Icon, {
        name: "fa-regular fa-star",
        className: "Button-icon",
        noStyleOverride: true
      }),
      label: app.translator.trans('flarum-subscriptions.forum.sub_controls.follow_button')
    },
    follow: {
      icon: m(Icon, {
        name: "fa-solid fa-star",
        className: "Button-icon",
        noStyleOverride: true
      }),
      label: app.translator.trans('flarum-subscriptions.forum.sub_controls.following_button')
    },
    ignore: {
      icon: 'far fa-eye-slash',
      label: app.translator.trans('flarum-subscriptions.forum.sub_controls.ignoring_button')
    }
  }))();
  view() {
    const discussion = this.attrs.discussion;
    const subscription = discussion.subscription();
    const buttonAttrs = this.possibleButtonAttrs[subscription ?? 'null'] ?? this.possibleButtonAttrs.null;
    const preferences = app.session.user.preferences();
    const notifyEmail = preferences['notify_newPost_email'];
    const notifyAlert = preferences['notify_newPost_alert'];
    const tooltipText = extractText(app.translator.trans(notifyEmail ? 'flarum-subscriptions.forum.sub_controls.notify_email_tooltip' : 'flarum-subscriptions.forum.sub_controls.notify_alert_tooltip'));
    const shouldShowTooltip = (notifyEmail || notifyAlert) && subscription === null;
    return m(SplitDropdown, {
      className: "SubscriptionMenu",
      buttonClassName: `SubscriptionMenu-button--${subscription}`,
      tooltip: shouldShowTooltip ? tooltipText : null,
      mainAction: m(Button, {
        className: 'SubscriptionMenu-button',
        icon: buttonAttrs.icon,
        onclick: this.saveSubscription.bind(this, discussion, ['follow', 'ignore'].indexOf(subscription) !== -1 ? null : 'follow')
      }, buttonAttrs.label)
    }, this.options.map(attrs => m(DetailedDropdownItem, Object.assign({}, attrs, {
      onclick: this.saveSubscription.bind(this, discussion, attrs.subscription),
      active: subscription === attrs.subscription
    }))));
  }
  saveSubscription(discussion, subscription) {
    discussion.save({
      subscription
    });

    // @ts-ignore
    this.$('.SubscriptionMenu-button').tooltip('hide');
  }
}
flarum.reg.add('flarum-subscriptions', 'forum/components/SubscriptionMenu', SubscriptionMenu);